import React from 'react';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import { FragmentItemsTypesSection } from '@modules/Steps/Shared/Ui/Wrappers/FragmentItemsTypesSection/FragmentItemsTypesSection';
import { FragmentInfoHeaderStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/FragmentInfoStep3/FragmentInfoHeaderStep3/FragmentInfoHeaderStep3';
import { FragmentInfoFooterStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/FragmentInfoStep3/FragmentInfoFooterStep3/FragmentInfoFooterStep3';
import { ItemsCheckedListTable } from '@modules/Steps/Components/Step3/Step3DesktopContent/FragmentInfoStep3/ItemsCheckedListTable/ItemsCheckedListTable';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';
import { useItemsSelectionStore } from '../../../../../../Stores/ItemsSelectionStore';

interface Props {
    fragment: ParsedFragmentEntity;
}

export const FragmentInfoStep3: React.FC<Props> = ({ fragment }) => {
    const fragmentsViewModel = new FragmentsViewModel();
    const selectedItemsViewModel = new ItemsSelectionViewModel();
    const { selectedItems } = useItemsSelectionStore();

    const totalPrice = fragmentsViewModel.getItemTypesTotal(fragment.itemTypes);
    const selectedTotal = selectedItemsViewModel.getSelectedTotalByItemTypes(
        fragment.itemTypes
    );
    const filteredItemTypes = fragment.itemTypes.filter(
        itemType => itemType.qty > 0
    );

    return (
        <FragmentItemsTypesSection>
            <FragmentInfoHeaderStep3 fragment={fragment} />
            <ItemsCheckedListTable itemTypes={filteredItemTypes} />
            <FragmentInfoFooterStep3
                grandTotal={totalPrice}
                selectedTotal={selectedTotal}
            />
        </FragmentItemsTypesSection>
    );
};
